import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

function App(props: { startedTime: number; finishedTime: number }) {
  const startedTime = props.startedTime;
  const finishedTime = props.finishedTime;
  const meetDuration = useMemo(() => finishedTime - startedTime, [finishedTime, startedTime]);
  const { t } = useTranslation();
  const isSameDay = useMemo(() => dayjs(startedTime).isSame(dayjs(finishedTime), 'day'), [finishedTime, startedTime]);

  return meetDuration > 60 * 60 * 1000 ? (
    <div className='py-2'>
      <div className='flex items-center justify-end'>
        <span>{dayjs(startedTime).format('MM-DD HH:mm')}</span>
        <span className='mx-1'>-</span>
        <span>{dayjs(finishedTime).format(isSameDay ? 'HH:mm' : 'MM-DD HH:mm')}</span>
      </div>
      <div className='mt-1 text-right text-[14px] text-[#0a0a17]'>
        {t('HMS', {
          hour: dayjs(finishedTime).diff(startedTime, 'hour'),
          min: dayjs.duration(meetDuration).format('mm'),
          sec: dayjs.duration(meetDuration).format('ss'),
        })}
      </div>
    </div>
  ) : meetDuration > 60 * 1000 ? (
    <div className='flex items-center justify-end'>
      <div className='flex items-center justify-end'>
        <span>{dayjs(startedTime).format('MM-DD HH:mm')}</span>
        <span className='mx-1'>-</span>
        <span>{dayjs(finishedTime).format('HH:mm')}</span>
      </div>
      <div className='mx-2 h-3 w-[1px] overflow-hidden bg-[rgba(19,20,21,.22)]' />
      <div className='text-right text-[14px] text-[#0a0a17]'>
        {t('MS', { min: dayjs.duration(meetDuration).format('mm'), sec: dayjs.duration(meetDuration).format('ss') })}
      </div>
    </div>
  ) : (
    <div className='flex items-center justify-end'>
      <div className='flex items-center justify-end'>
        <span>{dayjs(startedTime).format('MM-DD HH:mm')}</span>
        <span className='mx-1'>-</span>
        <span>{dayjs(finishedTime).format('HH:mm')}</span>
      </div>
      <div className='mx-2 h-3 w-[1px] overflow-hidden bg-[rgba(19,20,21,.22)]' />
      <div className='text-right text-[14px] text-[#0a0a17]'>
        {t('S', { sec: dayjs.duration(meetDuration).format('ss') })}
      </div>
    </div>
  );
}

export default App;
